import { ConvertData } from './Construction'

export enum CodeValidationDiscipline {
  Architectural = 'architectural',
  Structural = 'structural',
  City = 'city',
  MEP = 'mep',
  Fire = 'fire',
  Other = 'other',
}

export const CodeValidationDisciplineColor: Record<
  CodeValidationDiscipline,
  string
> = {
  [CodeValidationDiscipline.Architectural]: '#004AC7',
  [CodeValidationDiscipline.Structural]: '#CBB8A9',
  [CodeValidationDiscipline.City]: '#33CCCC',
  [CodeValidationDiscipline.MEP]: '#FC356F',
  [CodeValidationDiscipline.Fire]: '#BAA6FF',
  [CodeValidationDiscipline.Other]: '#747474',
}

export enum CodeValidationStatus {
  Critical = 'CRITICAL',
  Advised = 'ADVISED',
  Verified = 'VERIFIED',
  Accepted = 'ACCEPTED',
  Passed = 'PASSED',
  Failed = 'FAILED',
}

export const CodeValidationStatusColor: Record<CodeValidationStatus, string> = {
  [CodeValidationStatus.Critical]: '#FF0004',
  [CodeValidationStatus.Advised]: '#FFD000',
  [CodeValidationStatus.Verified]: '#00C961',
  [CodeValidationStatus.Accepted]: '#8CBAFF',
  [CodeValidationStatus.Passed]: '#00C961',
  [CodeValidationStatus.Failed]: '#FF2F5F',
}

export enum CodeValidationAgent {
  Architecture = 'Architecture',
  Engineering = 'Engineering',
  PermitValidation = 'Permit Validation',
  AutoAgent = 'Auto Agent',
}

export interface CodeValidationOption {
  id: string
  title: string
  description: string
}

export interface CodeValidationRule {
  id: string
  codeId: string
  codeReference: string
  codeClassification?: string
  description: string
  discipline: CodeValidationDiscipline
  atomics: CodeValidationAtomicRule[]
  status?: CodeValidationStatus
  elementsIds?: string[]
  elements?: CodeValidationRuleStatus[]
}

export interface CodeValidationAtomicRule {
  id: string
  description: string
  logicalDescription: string
  codeCategory?: string
}

export interface CodeValidationRuleStatus {
  ruleId: string
  elementId: string
  elementType?: string
  discipline: CodeValidationDiscipline
  status: CodeValidationStatus
  code?: CodeDetail
  fixingSuggestion: string
}

export type TaskStatus = 'PENDING' | 'IN_PROGRESS' | 'FAILED' | 'COMPLETED'

export interface Task {
  taskId: string
  status: TaskStatus
  createdAt: string
  updatedAt: string
}

export interface CodeDetail {
  description: string
  codeReference: string
  codeId: string
  elements: CodeValidationRuleStatus[]
  atomics?: CodeValidationAtomicRule[]
  status: CodeValidationStatus
  conflict: 'Code Conflicts' | 'Design Conflicts'
  discipline: CodeValidationDiscipline
}

export interface CodeGroup {
  groupName: string
  codes: CodeDetail[]
}

export interface CodeDetailsAccordionProps {
  codeGroups: CodeGroup[]
  buildingData: ConvertData
}

export interface CodeValidationSummaryProps {
  codeGroups: CodeGroup[]
}

export interface CodeDetailsListProps {
  codes: CodeDetail[]
}

export interface GroupedCodeDetailListProps {
  codes: CodeDetail[]
  elements: CodeValidationRuleStatus[]
  buildingData: ConvertData
}

export interface CodeDetailsContainerProps {
  codeGroups: CodeGroup[]
  buildingData: ConvertData
}
